import Script from 'next/script';

export const ProductionScripts = () => {
  // Directly return the elements, KetchCookieConsent now decides the script itself
  if (process.env.NEXT_PUBLIC_SANITY_DATASET !== 'production') {
    return <KetchCookieConsent />;
  }
  return (
    <>
      <KetchCookieConsent />
      <MicrosoftClarity />
      <FontLicence />
    </>
  );
};

export const KetchCookieConsent = () => {
  // Determine the base URL based on NODE_ENV
  const scriptBaseUrl =
    process.env.NEXT_PUBLIC_SANITY_DATASET !== 'production'
      ? 'https://global.ketchcdn.com/web/v2/config/multiverse_test/'
      : 'https://global.ketchcdn.com/web/v2/config/multiverse/';

  const scriptContent = `
    !(function () {
      (window.semaphore = window.semaphore || []),
      (window.ketch = function () {
        window.semaphore.push(arguments);
      });
      var e = new URLSearchParams(document.location.search),
          o = e.has('property') ? e.get('property') : 'website_smart_tag',
          n = document.createElement('script');
      n.type = 'text/javascript';
      n.src = '${scriptBaseUrl}'.concat(o, '/boot.js');
      n.defer = n.async = true;
      document.getElementsByTagName('head')[0].appendChild(n);
    })();
  `;

  return (
    <Script id="ketch-cookie-consent-script" type="text/javascript">
      {scriptContent}
    </Script>
  );
};

export const InitDynamicYield = () => {
  return (
    <>
      <link rel="preconnect" href="//cdn-eu.dynamicyield.com" />
      <link rel="preconnect" href="//st-eu.dynamicyield.com" />
      <link rel="preconnect" href="//rcom-eu.dynamicyield.com" />
      <link rel="dns-prefetch" href="//cdn-eu.dynamicyield.com" />
      <link rel="dns-prefetch" href="//st-eu.dynamicyield.com" />
      <link rel="dns-prefetch" href="//rcom-eu.dynamicyield.com" />
    </>
  );
};

export const INTERCOM_APP_ID = 'tvl27sse';

export const Intercom = () => {
  return (
    <script
      id="intercom-script"
      type="text/javascript"
      // eslint-disable-next-line
      dangerouslySetInnerHTML={{
        __html: `
        (function () {
          var w = window;
          var ic = w.Intercom;
          if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
          } else {
            var d = document;
            var i = function () {
              i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
              i.q.push(args);
            };
            w.Intercom = i;
            var l = function () {
              var s = d.createElement("script");
              s.type = "text/javascript";
              s.async = true;
              s.src = "https://widget.intercom.io/widget/${INTERCOM_APP_ID}";
              var x = d.getElementsByTagName("script")[0];
              x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === "complete") {
              l();
            } else if (w.attachEvent) {
              w.attachEvent("onload", l);
            } else {
              w.addEventListener("load", l, false);
            }
          }
        })();
      `,
      }}
    />
  );
};

const MicrosoftClarity = () => (
  <Script
    id="clarity-script"
    type="text/javascript"
    // eslint-disable-next-line
    dangerouslySetInnerHTML={{
      __html: `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.defer=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "44qgf2zuoa");`,
    }}
  />
);

const FontLicence = () => {
  /**
   * Unpacked from mtiFontTrackingCode.js
   * User details found in demo file within font package
   */

  const MTUserId =
    process.env.NODE_ENV === 'production'
      ? 'e24aa2ec-871e-48a1-b9c3-8624e8ad1193'
      : '';
  const MTFontIds = [
    '5596187', // Times New Roman® W01 Condensed
  ];

  return (
    <Script
      id="font-script"
      type="text/javascript"
      // eslint-disable-next-line
      dangerouslySetInnerHTML={{
        __html: `
        (function() {
          var mtTracking = document.createElement('script');
          mtTracking.type='text/javascript';
          mtTracking.defer='true';
          mtTracking.src='//fast.fonts.net/lt/1.css?apiType=css&c=${MTUserId}&fontids=${MTFontIds.join(
            ',',
          )}';

          (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(mtTracking);
        })();
    `,
      }}
    />
  );
};
